import {Component, Input} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {EventResponse} from '../../../../../../../../../../@shared/models/response.module';
import {EventsService} from '../../../../../../../../../../@shared/services/events-service';
import {_AQH_EVE_5} from '../../../../../../../../../../@shared/models/input.module';

@Component({
  selector: 'app-edit-event-images',
  standalone: false,
  templateUrl: './edit-event-images.html',
  styleUrl: './edit-event-images.css'
})
export class EditEventImages {
  @Input() event: EventResponse

  headerFile: File | null = null;
  imageFile: File | null = null;

  constructor(private eventsService: EventsService,
              private modal: NgbActiveModal) {
  }

  onSaveHeader() {
    if (!this.headerFile) {
      return;
    }

    const payload: _AQH_EVE_5 = {
      event_id: this.event.event_id,
      image_type: 'header',
      image: this.headerFile
    };

    this.eventsService.editEventFiles(payload).subscribe(() => {
      this.modal.close(true);
    });
  }

  onSaveImage() {
    if (!this.imageFile) {
      return;
    }

    const payload: _AQH_EVE_5 = {
      event_id: this.event.event_id,
      image_type: 'image',
      image: this.imageFile
    };

    this.eventsService.editEventFiles(payload).subscribe(() => {
      this.modal.close(true);
    });
  }

  close() {
    this.modal.close();
  }
}
